import React from "react";
import "./machnav.css";
import { FaFutbol, FaGavel } from "react-icons/fa";
import { MdSportsCricket } from "react-icons/md";

const MachNav = () => {
  const matches = [
    {
      icon: <MdSportsCricket className="text-[15px]" />,
      text: "Delhi Capitals W v Mumbai i...",
    },
    {
      icon: <FaFutbol className="text-[15px]" />,
      text: "Perth Glory v Brisbane Roar",
    },
    {
      icon: <FaFutbol className="text-[15px]" />,
      text: "Valladolid v Celta Vigo",
    },
    { icon: <FaFutbol className="text-[15px]" />, text: "AC Monza v Parma" },
    {
      icon: <FaFutbol className="text-[15px]" />,
      text: "Western Sydney Wanderers ...",
    },
  ];
  return (
    <>
      <div className="flex gap-1 !pt-1 !pb-1 md:bg-[#ffff] bg-[#1a5684] overflow-x-auto whitespace-nowrap scrollbar-hide">
        {matches.map((match, index) => (
          <div
            key={index}
            className="flex items-center rounded !pl-2 !pr-2 !pt-[8px] justify-center !pb-[8px] bg-[#212529] px-4 py-2  text-white text-sm font-[500]"
          >
            <span className="text-gray-300 text-lg !ml-2 !mr-2 blinking-text">
              {match.icon}
            </span>
            <span
              style={{ textWrap: "nowrap" }}
              className="text-[12px] font-[500] blinking-text"
            >
              {match.text}
            </span>
          </div>
        ))}
      </div>
      <div className="bg-[#1a3d5c] text-white w-full md:hidden">
        {/* Tabs */}
        <div className="flex border-t border-white border-b border-white">
          {["IN-PLAY", "SPORTS", "OUR CASINO", "FANTACY"].map((tab, idx) => (
            <div
              key={idx}
              className="flex-1 items-center flex text-center justify-center py-2 h-[38px] border-r border-white bg-[#097fc9] font-semibold text-[11.5px] cursor-pointer hover:bg-[#0a91e9]"
            >
              {tab}
            </div>
          ))}
        </div>

      
      </div>
    </>
  );
};

export default MachNav;
